export default __webpack_public_path__ + "icon-justhatched.4ba0b34f.png";